import BotCampaignReportingNavbar from './BotCampaignReportingNavbar'

export default BotCampaignReportingNavbar;
